<template>
  <BaseModal id="label-creation" :value="value" @input="changeStatus">
    <h1>Update Return</h1>
    <BaseForm ref="form" @submit="submitForm">
      <BaseSelectField
        v-model="newReturnShipmentPaidBy"
        :options="paidByOptions"
        label="Shipment paid by"
        required
        :rules="rules.paidBy"
      />
      <BaseSelectField
        v-model="newResolution"
        :options="resolutionOptions"
        label="resolution"
        required
        :rules="rules.paidBy"
      >
      </BaseSelectField>
      <BaseTextField
        v-model="newEstimatedRefund"
        type="number"
        step="0.01"
        label="Estimated refund"
        required
      />
      <BaseTextField
        v-model="newAmountRefunded"
        type="number"
        step="0.01"
        label="Amount refunded"
        required
      />
      <template v-slot:actions>
        <div class="flex flex-row gap-2">
          <button class="btn-success-button">
            <span v-if="!loading">
              save
            </span>
            <base-mini-spinner v-else></base-mini-spinner>
          </button>
          <button
            class="btn-dark-button"
            type="button"
            @click="changeStatus(false)"
          >
            close
          </button>
        </div>
      </template>
    </BaseForm>
  </BaseModal>
</template>
<script>
import { updateReturn } from "@/api/store/ReturnsService.js";
export default {
  name: "EditReturnModal",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    estimatedRefund: {
      type: Number,
      required: true
    },
    returnShipmentPaidBy: {
      type: String,
      required: true
    },
    amountRefunded: {
      type: Number,
      required: true
    },
    returnId: {
      type: String,
      required: true
    },
    resolution: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      resolutionOptions: [
        {
          name: "Refund",
          code: "Refund"
        },
        {
          name: "Replaced",
          code: "Replaced"
        },
        {
          name: "Partially refunded",
          code: "Partially refunded"
        },
        {
          name: "Refunded without shipping",
          code: "Refunded without shipping"
        }
      ],
      paidByOptions: [
        {
          name: "Select who pay for the return shipment",
          code: ""
        },
        {
          name: "Customer",
          code: "Customer"
        },
        {
          name: "NKR DIESEL PARTS",
          code: "NKR DIESEL PARTS"
        }
      ],
      newReturnShipmentPaidBy: this.returnShipmentPaidBy || "",
      refundedAmount: this.estimatedRefund,
      newAmountRefunded: this.amountRefunded,
      newResolution: this.resolution,
      loading: false,
      rules: {
        paidBy: [
          v => !!v || "Paid by is required",
          v => !v || v.length > 0 || "Name must not be empty"
        ]
      },
      newEstimatedRefund: this.estimatedRefund
    };
  },
  methods: {
    changeStatus(newStatus) {
      if (this.loading) return;
      this.$emit("input", newStatus);
    },
    async submitForm() {
      if (this.validate()) {
        this.loading = true;
        try {
          await updateReturn(
            this.returnId,
            this.newReturnShipmentPaidBy,
            this.newEstimatedRefund,
            this.newAmountRefunded,
            this.newResolution
          );
          this.$toast.open({
            message: `return updated.`,
            type: "success",
            position: "top-right"
          });
          this.$emit("updatedReturn");
          this.loading = false;
          this.changeStatus(false);
        } catch (error) {
          this.$toast.open({
            message: `Error updating return.`,
            type: "error",
            position: "top-right"
          });
          this.loading = false;
          this.$refs.form.addError("Error updating return.");
        }
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        return true;
      }
      this.$toast.open({
        message: `Please fill the form.`,
        type: "error",
        position: "top-right"
      });
      return false;
    }
  }
};
</script>
